export default __webpack_public_path__ + "static/bill-curl-tr-804bb4d64a14d5de857bd24bc195b6a6.png";